import { getCurrentDateWithDay } from "@/helpers/format-date";
import { WeatherDispatch, WeatherSelect } from "@/store/type";
import { useDispatch, useSelect } from "@wordpress/data";
import { WEATHER_STORE } from "@/store/store";

import PrevisionDescriptionCardHeader from "../prevision-description-header-card/PrevisionDescriptionCardHeader";

import "./style.scss";
import { findDailyForecastById } from "@/helpers/daily-forecast-helpers";

type PrevisionDescriptionHeaderProps = {
	selectedDate: Date;
	isMarine: boolean;
};

export const PrevisionDescriptionHeader = ({
	selectedDate,
	isMarine,
}: PrevisionDescriptionHeaderProps) => {
	const { setPrevisionDateCard, setDateKuwaitForecast } = useDispatch(
		WEATHER_STORE,
	) as WeatherDispatch;

	const { dayliesData } = useSelect(
		(select: (store: typeof WEATHER_STORE) => WeatherSelect) =>
			select(WEATHER_STORE).getDailyForecast(),
		[],
	);

	const findDailyForecast = findDailyForecastById("40582", dayliesData, 5);

	const data = findDailyForecast.map((item, index) => {
		const kuwaitCurrentTimeStr = new Date().toLocaleString("en-US", {
			timeZone: "Asia/Kuwait",
		});

		const date = new Date(kuwaitCurrentTimeStr);

		date.setDate(date.getDate() + index);

		const { day, date: formattedDate } = getCurrentDateWithDay(date);

		return {
			ww: item?.ww,
			tempMax: item?.temperature_max ?? "-",
			tempMin: item?.temperature_min ?? "-",
			date,
			dayWeek: formattedDate,
			day,
		};
	});

	return (
		<div className="prevision-description-header">
			{data.map((card, index) => (
				<PrevisionDescriptionCardHeader
					key={index}
					data={card}
					isActive={selectedDate.getDate() === card.date.getDate()}
					handleClick={() => {
						setPrevisionDateCard({
							type: isMarine ? "marine" : "weather",
							date: card.date,
						});

						setDateKuwaitForecast(card.date);
					}}
				/>
			))}
		</div>
	);
};

export default PrevisionDescriptionHeader;
